"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formResultFactory = exports.formResultAnswerFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.formResultAnswerFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    question_id: 1,
    question_name: 'Why is a spinning mouse?',
    question_element_label: null,
    form_result_id: 1,
    persona_id: mocks_1.persona.id,
    value_type: 'FormBuilder::ShortTextAnswer',
    value_id: 1,
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    question_element_id: 1,
    report_name: 'Why_is_mouse',
    position: Factory.each(i => i + 1),
    value: 'The higher he flys the much',
    display_value: 'The higher he flys the much',
    editable_by_user: false,
});
exports.formResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    form_id: 1,
    form_name: 'Test Form',
    persona_id: mocks_1.persona.id,
    survey_result_id: 1,
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    answers: exports.formResultAnswerFactory.buildList(1)
});
